import httpClient from '@/api/httpClient';

const sendReport = report =>
  httpClient.post('/server-error', JSON.stringify(report), { 'Content-Type': 'application/json' });

export { sendReport };
